import { createTheme } from "@mui/material";

export const theme = createTheme({
  typography: {
    fontFamily: 'noto Sans JP, Roboto, "Helvetica Neue", Arial, sans-serif',
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
  }
})